import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './pages/MainPage';
import Login from './pages/login';
import Register from './pages/register';
import Dashboard from './pages/dashboard';
import AdminPanel from './pages/AdminPanel';
import ResetPassword from './pages/reset-password';
import Recover from './pages/recover';
import Profile from './pages/profile';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';

function RedirectTo({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
}

function NotFound() {
  useEffect(() => {
    document.title = 'Página no encontrada | KER';

    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', 'noindex, nofollow');
  }, []);

  return <div style={{ padding: '4rem 1.5rem', textAlign: 'center' }}><h1>Página no encontrada</h1><p>La URL solicitada no existe en el sitio actual.</p><a href="/">Volver al inicio</a></div>;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/contact" element={<RedirectTo to="/#contacto" />} />
        <Route path="/contact/*" element={<RedirectTo to="/#contacto" />} />
        <Route path="/services" element={<RedirectTo to="/" />} />
        <Route path="/services/*" element={<RedirectTo to="/" />} />
        <Route path="/solutions" element={<RedirectTo to="/" />} />
        <Route path="/solutions/*" element={<RedirectTo to="/" />} />
        <Route path="/reserve" element={<RedirectTo to="/" />} />
        <Route path="/reserve/*" element={<RedirectTo to="/" />} />
        <Route path="/hello-world" element={<RedirectTo to="/" />} />
        <Route path="/hello-world/*" element={<RedirectTo to="/" />} />
        <Route path="/author/*" element={<RedirectTo to="/" />} />
        <Route path="/category/*" element={<RedirectTo to="/" />} />
        <Route path="/wp-sitemap-posts-page-1.xml" element={<RedirectTo to="/sitemap.xml" />} />
        <Route path="/la-importancia-del-mantenimiento-tecnico-de-calderas-industriales" element={<RedirectTo to="/" />} />
        <Route path="/la-importancia-del-mantenimiento-tecnico-de-calderas-industriales/" element={<RedirectTo to="/" />} />
        <Route path="/la-importancia-del-mantenimiento-tecnico-en-calderas-industriales-y-automatizacion" element={<RedirectTo to="/" />} />
        <Route path="/la-importancia-del-mantenimiento-tecnico-en-calderas-industriales-y-automatizacion/" element={<RedirectTo to="/" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
        <Route path="/recover" element={<Recover />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/" element={<App />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

